import React from 'react';
import { Link } from 'react-router-dom';
import { PageNotFoundSvgIcon } from './IconProvider';
import { useTranslation } from 'react-i18next';
const PageNotFound = () => {
  const { t } = useTranslation('common');
  return (
    <div className="w-full py-4">
      <div className="bg-white p-4 rounded-2xl w-full min-h-[calc(100vh-76px-60px-32px-32px)] flex items-center justify-center">
        <div className="text-center">
          <PageNotFoundSvgIcon />
          <h3 className="text-3xl font-semibold mb-3">
            {t('something_went_wrong')}
          </h3>
          <p className="text-gray-700 mb-5">{t('page_not_found')}</p>
          <Link to="/">
            <button className="px-6 py-4 text-white bg-brandBlue rounded-lg">
              {t('back_to_home')}
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PageNotFound;
